import React from "react";
import { List, ListItem } from "@mui/material";
import SvgIcon from "./SvgIcon";
function Loader(props) {
  const { loading } = props;
  return (
    <>
      {loading ? (
        <div className="loader--wrapper">
          <div className="loader--icon--wrapper">
            <SvgIcon name="pm-screen" />
            <div id="loader" className="loader--graph--bars">
              <List>
                <ListItem />
                <ListItem />
                <ListItem />
                <ListItem />
                <ListItem />
              </List>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Loader;
